import {
  ITimelineEvent,
  TimelineEventType,
} from "@shared/lib/types/briefInfluencerV2";
import { Flex, Timeline } from "antd";
import { format } from "date-fns";
export interface IBriefTimelineProps {
  timeline: ITimelineEvent[];
  brandTimeLine: ITimelineEvent[];
  type: "brand" | "influencer";
}

function formatDate(dateStr: string) {
  const date = new Date(dateStr);
  return format(date, "dd MMM yyyy");
}

function getEventTitle(event: ITimelineEvent, type: "brand" | "influencer") {
  if (type === "influencer") {
    switch (event.type) {
      case TimelineEventType.InitialInfluencerCostAsked:
        return "Commercials  Asked";
      case TimelineEventType.InitialInfluencerCostAskedTarget:
        return `Target Commercial Given: ${
          event.targetInfluencerCost?.cost ?? "-"
        }`;
      case TimelineEventType.InitialInfluencerCostAccepted:
        return `Commercial Accepted: ${event.influencerCost?.cost ?? "-"}`;
      case TimelineEventType.InitialInfluencerCostSubmitted:
        return `1st Quote Submitted: ${event.influencerCost?.cost ?? "-"}`;
      case TimelineEventType.InfluencerNegotiationsRequested:
        return `Negotiation Requested: ${
          event.targetInfluencerCost?.cost ?? "-"
        }`;
      case TimelineEventType.InfluencerNegotiationsAccepted:
        return `Negotiation Accepted: ${event.influencerCost?.cost ?? "-"}`;

      case TimelineEventType.InfluencerInitialCost:
        return `Influencer cost added: ${event.influencerCost?.cost ?? "-"}`;
      case TimelineEventType.BrandInitialCost:
        return `Brand price added: ${event.brandCost?.cost ?? "-"}`;
      case TimelineEventType.NewInfluencerCost:
        return `New Influencer cost added: ${
          event.influencerCost?.cost ?? "-"
        }`;
      case TimelineEventType.NewBrandCost:
        return `New Brand price added: ${event.brandCost?.cost ?? "-"}`;
      case TimelineEventType.NegotiationsRequested:
        return "Brand cost negotiation requested";
      case TimelineEventType.NegotiationsRequestedInfluencer:
        return "Influencer cost negotiation requested";
      default:
        return event.type;
    }
  } else {
    switch (event.type) {
      case TimelineEventType.BrandInitialCost:
        return `Price added: ${event.brandCost?.cost ?? "-"}`;
      case TimelineEventType.NegotiationsRequested:
        return `You created counter offer: ${
          event.targetBrandCost?.cost ?? " - "
        }`;
      case TimelineEventType.NewBrandCost:
        return `New Brand price added: ${event.brandCost?.cost ?? "-"}`;
      default:
        return event.type;
    }
  }
  // Add brand-specific logic here if needed
}

function getEventDetails(event: ITimelineEvent, type: "brand" | "influencer") {
  if (type === "influencer") {
    switch (event.type) {
      case TimelineEventType.BrandInitialCost:
      case TimelineEventType.NewBrandCost:
        return (
          <div style={{ color: "#3B5BDB", marginTop: 4, fontSize: 12 }}>
            <div>
              Influencer Commercial:{" "}
              {event.brandCost?.influencerCost?.cost ?? "-"}
            </div>
            <div>Brand Price: {event.brandCost?.cost ?? "-"}</div>
            <div>
              Revenue: {event.brandCost?.revenue} (
              {(event.brandCost?.marginPercentage || 0).toFixed(2)}%)
            </div>
            <div>Notes: {event.brandCost?.note ?? "-"}</div>
          </div>
        );
      case TimelineEventType.NegotiationsRequestedInfluencer:
      case TimelineEventType.NegotiationsRequested:
        return (
          <div style={{ color: "#3B5BDB", marginTop: 4, fontSize: 14 }}>
            <div>Target Brand Price: {event.targetBrandCost?.cost ?? "-"}</div>
            <div>
              Target Influencer Price: {event.targetInfluencerCost?.cost ?? "-"}
            </div>
            <div>Notes: {event.targetRemarks ?? "-"}</div>
          </div>
        );
      default:
        return null;
    }
  } else {
    switch (event.type) {
      case TimelineEventType.BrandInitialCost:
      case TimelineEventType.NewBrandCost:
        return (
          <div style={{ color: "#3B5BDB", marginTop: 4, fontSize: 12 }}>
            <div>Notes: {event.brandCost?.note ?? "-"}</div>
          </div>
        );
      case TimelineEventType.NegotiationsRequested:
        return (
          <div style={{ color: "#3B5BDB", marginTop: 4, fontSize: 14 }}>
            <div>Notes: {event.targetRemarks ?? "-"}</div>
            <div>Tips: {event.tips ?? "-"}</div>
          </div>
        );
      default:
        return null;
    }
  }
}

export function BriefTimeline({
  timeline,
  type,
  brandTimeLine,
}: IBriefTimelineProps) {
  return (
    <div style={{ padding: 24 }}>
      <Timeline style={{ maxHeight: 600, overflow: "auto", padding: "10px 0" }}>
        {(type === "brand" ? brandTimeLine : timeline).map((event, idx) => (
          <Timeline.Item key={idx} color="#3B5BDB">
            <Flex justify="space-between" style={{ alignItems: "center" }}>
              <div style={{ fontSize: 16, fontWeight: 500 }}>
                {getEventTitle(event, type)}
              </div>
              <span
                style={{
                  color: "#ADB5BD",
                  fontSize: 12,
                  fontWeight: 400,
                  marginLeft: 12,
                }}
              >
                {event?.createdAt ? formatDate(event?.createdAt) : ""} by{" "}
                {event?.createdBy?.firstName}
              </span>
            </Flex>

            {getEventDetails(event, type)}
            {/* {event.type === TimelineEventType.NegotiationsRequested && (
              <div
                style={{
                  display: "inline-block",
                  marginTop: 12,
                  padding: "2px 16px",
                  borderRadius: 16,
                  background: "#EDF2FF",
                  color: "#3B5BDB",
                  fontWeight: 500,
                  fontSize: 16,
                  border: "1px solid #3B5BDB",
                }}
              >
                Brand
              </div>
            )} */}
          </Timeline.Item>
        ))}
      </Timeline>
    </div>
  );
}
